import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { pricingMicrocopy } from '../data/content';
export function Pricing() {
  return <section id="erbjudande" className="w-full scroll-mt-16 bg-white px-5 py-20 sm:px-8" data-id="element-139" data-mp="2ohe5m6lf2fb4">
      <div className="mx-auto w-full max-w-2xl" data-id="element-140" data-mp="2jkxkzmdfej2s">
        <div className="text-center" data-id="element-141" data-mp="1vts371nxdgpu">
          <Reveal data-id="element-142" data-mp="1vutf18crm78m">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-gold-dark" data-id="element-143" data-mp="1vubmomt84d5z">
              Lanseringserbjudande
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-144" data-mp="25shkas7zyx51">
            <h2 className="mt-5 text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-145" data-mp="25tiyh5kb7zqz">
              Få hela Innebandy Ready idag
            </h2>
          </Reveal>

          <Reveal delay={0.12} data-id="element-146" data-mp="3h5thwld5yjir">
            <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-muted" data-id="element-147" data-mp="3h97n01d7p6tw">
              Allt du behöver för att planera och genomföra innebandy med en tydlig
              progression från 6 till 16 år — samlat i ett komplett digitalt paket.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.18} data-id="element-148" data-mp="9s8sr3datq96">
          <div className="mt-12 overflow-hidden rounded-3xl border border-sand bg-cream shadow-[0_24px_60px_-40px_rgba(22,50,79,0.5)]" data-id="element-149" data-mp="9rz0f94s770b">
            <p className="bg-navy px-6 py-3.5 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-gold" data-id="element-150" data-mp="eqk2le3lg0re">
              Innebandy Ready — kompletta paketet
            </p>

            <div className="px-7 py-9 sm:px-10" data-id="element-151" data-mp="3i8k182n9etsc">
              <div className="space-y-5" data-id="element-152" data-mp="3n7etrwb13wpn">
                <div className="flex items-baseline justify-between gap-4 border-b border-sand pb-5" data-id="element-153" data-mp="3n6da53fy61wb">
                  <div data-id="element-154" data-mp="3rzeq7erw47hh">
                    <p className="text-sm font-extrabold uppercase tracking-wide text-navy" data-id="element-155" data-mp="3rzy5enq5ohrt">
                      10 kompletta volymer
                    </p>
                    <p className="mt-1 text-xs text-muted" data-id="element-156" data-mp="2zgiy2o3gchd4">Ordinarie pris: 899 kr</p>
                  </div>
                  <p className="font-serif text-2xl leading-none text-navy/60" data-id="element-157" data-mp="2rfjuj9slggki">899 kr</p>
                </div>

                <div className="flex items-baseline justify-between gap-4" data-id="element-158" data-mp="2mhi2w0h3r8xf">
                  <div data-id="element-159" data-mp="315mr1jyxccnl">
                    <p className="text-sm font-extrabold uppercase tracking-wide text-navy" data-id="element-160" data-mp="315wdwyooa3p2">
                      5 exklusiva bonusar
                    </p>
                    <p className="mt-1 text-xs text-muted" data-id="element-161" data-mp="28h7ceyjpfwcs">Samlat värde: 1 205 kr</p>
                    <p className="mt-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-level-green" data-id="element-162" data-mp="23jfk43f5e882">
                      Ingår gratis idag
                    </p>
                  </div>
                  <p className="font-serif text-2xl leading-none text-level-green" data-id="element-163" data-mp="2dgka6ec46nu5">
                    0 kr
                  </p>
                </div>
              </div>

              <hr className="my-8 border-sand" data-id="element-164" data-mp="3tx6drduqc8uc" />

              <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-muted" data-id="element-165" data-mp="3ov7as52wjdxx">
                Totalt värde idag:{' '}
                <span className="font-serif text-xl normal-case tracking-normal text-navy" data-id="element-166" data-mp="cqappr5t86m">
                  2 104 kr
                </span>
              </p>

              <div id="lanseringspris" className="mt-8 scroll-mt-16" data-id="element-167" data-mp="3ngej5irocjzp">
                <div className="rounded-2xl border border-gold/50 bg-white px-6 py-8 text-center" data-id="element-168" data-mp="3rfwubmtp1gpc">
                  <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-gold-dark" data-id="element-169" data-mp="j0li8rw6hpra">
                    Lanseringspris
                  </p>

                  <p className="mt-4 font-serif text-2xl leading-none text-muted line-through" data-id="element-170" data-mp="o1srywhvsz0l">
                    899 kr
                  </p>

                  <p className="mt-2 font-serif text-[86px] leading-[0.9] text-navy sm:text-[104px]" data-id="element-171" data-mp="e93ha3u5np6b">
                    249 kr
                  </p>

                  <p className="mt-3 text-[11px] font-extrabold uppercase tracking-[0.18em] text-muted" data-id="element-172" data-mp="11xwhicht8j6q">
                    Engångsbetalning
                  </p>
                </div>

                <div className="mt-8" data-id="element-173" data-mp="3f5fkeuyjun5l">
                  <CtaButton label="Ja! Jag vill ha Innebandy Ready" href={CHECKOUT_URL} data-id="element-174" data-mp="3a7w7pzhi2ifr" />
                </div>

                <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-175" data-mp="35b5s1d9lxouv">
                  {pricingMicrocopy.map(item => <li key={item} className="flex items-center gap-2" data-id="element-176" data-mp="1scj5drrxo71">
                      <CheckIcon className="h-4 w-4 shrink-0 text-level-green" aria-hidden="true" data-id="element-177" data-mp="1uq8d5zrw66o" />
                      <span className="text-sm font-semibold text-navy" data-id="element-178" data-mp="3o6vsux5t0f76">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}